import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAFAF7] px-6 text-slate-900">
      <div className="w-full max-w-md border border-slate-200 bg-white p-10 text-center">
        <XCircle className="mx-auto mb-4 h-12 w-12 text-slate-500" />
        <h1 className="font-serif text-3xl font-semibold">No charge made.</h1>
        <p className="mt-3 text-sm text-slate-500">
          You canceled the checkout. Come back whenever you're ready.
        </p>
        <Link
          to="/pricing"
          className="mt-8 inline-flex items-center gap-2 bg-[#2563EB] px-5 py-3 text-sm font-semibold text-white hover:bg-[#1D4ED8]"
        >
          Back to pricing
        </Link>
      </div>
    </div>
  );
}
